import script from "./SiteFooter.vue?vue&type=script&setup=true&lang=ts"
export * from "./SiteFooter.vue?vue&type=script&setup=true&lang=ts"

import "./SiteFooter.vue?vue&type=style&index=0&id=49ea4829&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49ea4829"]])

export default __exports__